import React from "react";
import { baseUrl } from "../../utils/base_url";
import pointerIcon from "../../assets/image/pointer.png";
import { useMediaQuery } from "react-responsive";
import {
  _1200px,
  _1400px,
  _1500px,
  _1600px,
  _1700px,
  _1800px,
  _576px,
  _768px,
  _992px,
} from "../../utils/mediaBreakpoints";

const AboutSecond = ({ isMobile, imgurl, heading, description, pointers }) => {
  const _576 = useMediaQuery({ maxWidth: _576px });
  const _768 = useMediaQuery({ maxWidth: _768px });
  const _992 = useMediaQuery({ maxWidth: _992px });
  const _1200 = useMediaQuery({ maxWidth: _1200px });
  const _1400 = useMediaQuery({ maxWidth: _1400px });
  const _1500 = useMediaQuery({ maxWidth: _1500px });
  const _1600 = useMediaQuery({ maxWidth: _1600px });
  const _1700 = useMediaQuery({ maxWidth: _1700px });
  const _1800 = useMediaQuery({ maxWidth: _1800px });
  return (
    <>
      <div
        className="container-fluid m-0 p-0"
        style={{ backgroundColor: " #090D23" }}
      >
        <div className="container px-0 pt-5 contwidth">
          <div className="row py-5 mt-5">
            <div className="col-lg-5 d-flex justify-content-center mb-5 mb-lg-0">
              <img
                //   data?.about_ask_fides?.image?.url
                src={`${baseUrl}${imgurl}`}
                alt=""
                className="abosecimg"
                style={{
                  width: isMobile ? "90%" : "539px",
                  height: isMobile ? "" : "649px",
                }}
              />
            </div>
            <div className="col-lg-7">
              <div className="d-flex flex-column gap-4 gap-xxl-5 px-0 ps-xl-4">
                <span
                  className={`text-white fw300 abosecsup ${
                    isMobile ? "fs20" : "fs30"
                  } `}
                >
                  {/* {data?.about_ask_fides?.super_heading} */}
                  {heading}
                </span>

                {description &&
                  (() => {
                    const phrase = "It’s a shift";
                    // data.about_ask_fides.description
                    const [before, after] = description.split(phrase);
                    return (
                      <p
                        className={`text-white abosecdes lh-sm fw800`}
                        style={{
                          fontSize: _576
                            ? "25px"
                            : _768
                            ? "35px"
                            : _992
                            ? "50px"
                            : _1200
                            ? "34px"
                            : _1400
                            ? "40px"
                            : _1600
                            ? "45px"
                            : _1700
                            ? "50px"
                            : _1800
                            ? "50px"
                            : "60px",
                        }}
                      >
                        {before}
                        <span style={{ color: " #459EFF" }}>{phrase}</span>
                        {after}
                      </p>
                    );
                  })()}

                <div className="d-flex flex-column gap-3">
                  {pointers
                    ? pointers?.map((pointer, idx) => (
                        <div
                          key={idx}
                          className={`d-flex align-items-center ${
                            isMobile ? "gap-2" : "gap-4"
                          }`}
                        >
                          <img src={pointerIcon} alt="" style={{width:"20px", height:"21px"}} className="align-self-start" />
                          <span
                            className={`text-white fw400 lh-sm abosecpoin`}
                            style={{
                              fontSize: _576
                                ? "15px"
                                : _768
                                ? "22px"
                                : _992
                                ? "24px"
                                : _1200
                                ? "15px"
                                : _1400
                                ? "15px"
                                : _1500
                                ? "17px"
                                : _1600
                                ? "18px"
                                : _1700
                                ? "20px"
                                : _1800
                                ? "22px"
                                : "24px",
                            }}
                          >
                            {pointer?.description}
                            {/* {pointerdes} */}
                          </span>
                        </div>
                      ))
                    : ""}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AboutSecond;
